// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.habit-form {
  position: relative;
  font-family: "Raleway";
  padding-bottom: 3rem;
}
.habit-form-header {
  font-size: 2rem;
  font-weight: 600;
  color: rgb(51, 51, 51);
  margin-bottom: 2.4rem;
}
.habit-form-title-input {
  width: 100%;
  padding: 0.8rem;
  border: none;
  border-bottom: 1px solid rgb(208, 213, 221);
  font-size: 1.6rem;
  margin-bottom: 1.8rem;
}
.habit-form-sub-header {
  font-size: 1.6rem;
  font-weight: 600;
  color: rgb(51, 51, 51);
  margin-top: 0;
  margin-bottom: 1.6rem;
}
.habit-form-tabs {
  display: flex;
  margin-bottom: 16px;
}
.habit-form-tab {
  display: flex;
  flex: 1;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
  font-size: 14px; /* Adjust as needed */
  font-weight: 600;
  color: #333; /* Adjust as needed */
}
.habit-form-tab .selected-icon {
  height: 2.5rem;
  width: 2.5rem;
  margin-left: 8px;
}
.habit-form-tab .selected-icon.selected > svg {
  fill: inherit;
}
.habit-form-tab .selected-icon.selected > svg > path {
  fill: inherit;
}
.habit-form-tab .selected-icon.selected .fill {
  fill: inherit;
}
.habit-form-tab .selected-icon.selected .stroke {
  stroke: inherit;
}
.habit-form-tab .selected-color {
  margin-left: 8px;
}
.habit-form-tab-active {
  border-bottom: 1px solid #ccc;
}
.habit-form-icon-library {
  margin-bottom: 3rem;
  height: 43vh;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 1.2rem;
}
@media (max-width: 768px) {
  .habit-form-icon-library {
    height: 33vh;
  }
}
.habit-form-icon-library .habit-icon {
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  cursor: pointer;
}
.habit-form-icon-library .habit-icon.selected > svg > path {
  fill: white;
}
.habit-form-icon-library .habit-icon.selected .fill {
  fill: white;
}
.habit-form-icon-library .habit-icon.selected .stroke {
  stroke: white;
}
.habit-form-color-library {
  height: 43vh;
  overflow-y: auto;
  margin-bottom: 3rem;
}
@media (max-width: 768px) {
  .habit-form-color-library {
    height: 33vh;
  }
}
.habit-form-color-library .sub-header {
  font-size: 1.4rem;
  color: #696969;
  margin-top: 2.4rem;
  margin-bottom: 1.6rem;
}
.habit-form-color-library .color-button-grid {
  display: grid;
  place-items: center;
  grid-template-columns: repeat(7, 1fr) !important;
  grid-gap: 1.2rem;
}
.habit-form-habit-action-buttons {
  display: flex;
  flex-direction: column;
  align-content: center;
}
.habit-form-habit-action-buttons .action-button {
  margin-inline: auto;
  margin-bottom: 1.6rem;
}
.habit-form-habit-action-buttons .action-button .action-icon {
  margin-right: 6px;
  height: 1.4rem;
  width: 1.4rem;
  fill: rgb(86, 86, 86);
}
.habit-form-habit-action-buttons .action-button .action-text {
  font-size: 1.4rem;
  color: rgb(86, 86, 86);
}
.habit-form .warning-message {
  color: red;
  word-wrap: break-word;
  max-width: 100%;
  overflow-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Habits/NewHabitForm.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AAEF;AAAE;EACE,eAAA;EACA,gBAAA;EACA,sBDaW;ECZX,qBAAA;AAEJ;AACE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,2CAAA;EACA,iBAAA;EACA,qBAAA;AACJ;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,sBDHW;ECIX,aAAA;EACA,qBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA,EAAA,qBAAA;EACA,gBAAA;EACA,WAAA,EAAA,qBAAA;AAFJ;AAGI;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AADN;AAIQ;EACE,aAAA;AAFV;AAIQ;EACE,aAAA;AAFV;AAKQ;EACE,aAAA;AAHV;AAMQ;EACE,eAAA;AAJV;AAQI;EACE,gBAAA;AANN;AAUE;EACE,6BAAA;AARJ;AAWE;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;AATJ;AAUI;EAPF;IAQI,YAAA;EAPJ;AACF;AASI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAPN;AAUQ;EACE,WAAA;AARV;AAWQ;EACE,WAAA;AATV;AAYQ;EACE,aAAA;AAVV;AAgBE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AAdJ;AAeI;EAJF;IAKI,YAAA;EAZJ;AACF;AAcI;EACE,iBAAA;EACA,cDrHU;ECsHV,kBAAA;EACA,qBAAA;AAZN;AAeI;EACE,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;AAbN;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAhBJ;AAkBI;EACE,mBAAA;EACA,qBAAA;AAhBN;AAkBM;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,qBDzHU;ACyGlB;AAmBM;EACE,iBAAA;EACA,sBD9HU;AC6GlB;AAuBE;EACE,UAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AArBJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import 'Variables.scss';\n\n.habit-form {\n  position: relative;\n  font-family: 'Raleway';\n  padding-bottom: 3rem;\n\n  &-header {\n    font-size: 2rem;\n    font-weight: 600;\n    color: $habitPrimary;\n    margin-bottom: 2.4rem;\n  }\n\n  &-title-input {\n    width: 100%;\n    padding: 0.8rem;\n    border: none;\n    border-bottom: 1px solid $habitBorder;\n    font-size: 1.6rem;\n    margin-bottom: 1.8rem;\n  }\n\n  &-sub-header {\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: $habitPrimary;\n    margin-top: 0;\n    margin-bottom: 1.6rem;\n  }\n\n  &-tabs {\n    display: flex;\n    margin-bottom: 16px;\n  }\n\n  &-tab {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    cursor: pointer;\n    padding: 8px 16px;\n    font-size: 14px; /* Adjust as needed */\n    font-weight: 600;\n    color: #333; /* Adjust as needed */\n    .selected-icon {\n      height: 2.5rem;\n      width: 2.5rem;\n      margin-left: 8px;\n\n      &.selected {\n        & > svg {\n          fill: inherit;\n        }\n        & > svg > path {\n          fill: inherit;\n        }\n\n        .fill {\n          fill: inherit;\n        }\n\n        .stroke {\n          stroke: inherit;\n        }\n      }\n    }\n    .selected-color {\n      margin-left: 8px;\n    }\n  }\n\n  &-tab-active {\n    border-bottom: 1px solid #ccc;\n  }\n\n  &-icon-library {\n    margin-bottom: 3rem;\n    height: 43vh;\n    overflow-y: auto;\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 1.2rem;\n    @media (max-width: $tablet) {\n      height: 33vh;\n    }\n\n    .habit-icon {\n      height: 3rem;\n      width: 3rem;\n      border-radius: 50%;\n      cursor: pointer;\n\n      &.selected {\n        & > svg > path {\n          fill: white;\n        }\n\n        .fill {\n          fill: white;\n        }\n\n        .stroke {\n          stroke: white;\n        }\n      }\n    }\n  }\n\n  &-color-library {\n    height: 43vh;\n    overflow-y: auto;\n    margin-bottom: 3rem;\n    @media (max-width: $tablet) {\n      height: 33vh;\n    }\n\n    .sub-header {\n      font-size: 1.4rem;\n      color: $darkTextColor;\n      margin-top: 2.4rem;\n      margin-bottom: 1.6rem;\n    }\n\n    .color-button-grid {\n      display: grid;\n      place-items: center;\n      grid-template-columns: repeat(7, 1fr) !important;\n      grid-gap: 1.2rem;\n    }\n  }\n\n  // Tracking toggle\n  &-habit-action-buttons {\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n\n    .action-button {\n      margin-inline: auto;\n      margin-bottom: 1.6rem;\n\n      .action-icon {\n        margin-right: 6px;\n        height: 1.4rem;\n        width: 1.4rem;\n        fill: $habitActionText;\n      }\n\n      .action-text {\n        font-size: 1.4rem;\n        color: $habitActionText;\n      }\n    }\n  }\n\n  //Warning message\n  .warning-message {\n    color: red;\n    word-wrap: break-word;\n    max-width: 100%;\n    overflow-wrap: break-word;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
